import {useRouter} from 'next/router';
import PropTypes from 'prop-types';

import {ROLES_NAMES} from '@/src/app/constants/roles';
import useTargetUserActions from '@/src/app/store/targetUser/useTargetUserActions';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import useTargetClinic from '@/src/profile/clinicTarget/hooks/useTargetClinic';

import SearchTabs from '../components/SearchTabs';
import {useSearchFilters} from '../utils/useSearchFilters';

const SearchTabsContainer = ({userType}) => {
  const {
    query: {username},
  } = useRouter();
  const {targetUser} = useTargetUserActions();
  const {
    statistic: {data: statisticData},
  } = useTargetClinic();

  const {
    WATCHLIST_BOOKMARKED_ROUTE,
    SEARCH_FOLLOWERS_ROUTE,
    SEARCH_FOLLOWINGS_ROUTE,
    CLINIC_SEARCH_FOLLOWERS_ROUTE,
    CLINIC_SEARCH_FOLLOWINGS_ROUTE,
    WATCHLIST_CONTINUE_ROUTE,
    WATCHLIST_FINISHED_ROUTE,
  } = useRoutePaths();
  // @ts-ignore
  const {isTargetUserPage, isWatchlistPage} = useSearchFilters();

  const watchlistTabs = [
    {
      id: 1,
      titleID: 'general.bookmarked',
      url: WATCHLIST_BOOKMARKED_ROUTE.getLink(),
    },
    {
      id: 2,
      titleID: 'general.continue',
      url: WATCHLIST_CONTINUE_ROUTE.getLink(),
    },
    {
      id: 3,
      titleID: 'general.finished',
      url: WATCHLIST_FINISHED_ROUTE.getLink(),
    },
  ];

  const subscribersTabs = [
    {
      id: 1,
      titleID: 'search.followers',
      count:
        userType === ROLES_NAMES.CLINIC
          ? statisticData.followers
          : targetUser.user_followers_count,
      url:
        userType === ROLES_NAMES.CLINIC
          ? // @ts-ignore
            CLINIC_SEARCH_FOLLOWERS_ROUTE.getLink(username)
          : // @ts-ignore
            SEARCH_FOLLOWERS_ROUTE.getLink(username),
    },
    {
      id: 2,
      titleID: 'search.following',
      count:
        userType === ROLES_NAMES.CLINIC
          ? statisticData.following
          : targetUser.user_followees_count,
      url:
        userType === ROLES_NAMES.CLINIC
          ? CLINIC_SEARCH_FOLLOWINGS_ROUTE.getLink(username as string)
          : SEARCH_FOLLOWINGS_ROUTE.getLink(username as string),
    },
  ];

  const getTabsType = () => {
    if (isWatchlistPage) {
      return watchlistTabs;
    }

    if (isTargetUserPage) {
      return subscribersTabs;
    }

    return [];
  };

  return (
    <SearchTabs
      title={isWatchlistPage ? 'menu.watchlist' : 'profile.subscribers'}
      tabs={getTabsType()}
    />
  );
};

SearchTabsContainer.propTypes = {
  title: PropTypes.string,
  tabs: PropTypes.array.isRequired,
  userType: PropTypes.string,
};

SearchTabsContainer.defaultProps = {
  tabs: [],
};

export default SearchTabsContainer;
